import React, { Component, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Switch } from 'react-router-dom';

import { Layout } from './components/Layout/Layout';
import Protected from "./components/Login/Protected";

import Logout from "./components/Login/Logout";

import Home from './components/Home/Home';

import ReportHours from './components/TimesheetTasking/ReportHours';
import ValidateHours from './components/TimesheetTasking/ValidateHours';
import Mockup from './components/TimesheetTasking/Mockup';
import Reports from './components/TimesheetTasking/Reports';
import ReportOvertimeEmployee from './components/TimesheetTasking/OvertimeEmployee';
import ReportUtilisation from './components/TimesheetTasking/ReportUtilisation';
import ExternalEmployeeImputation from './components/TimesheetTasking/ExternalEmployeeImputation';
import ReportQHSE from './components/TimesheetTasking/ReportQHSE';
import AdminPeriodos from './components/TimesheetTasking/AdminPeriodos';

import { getUserLogged } from "./services/loginClient";
import * as apiClient from "./services/apiClient";

import './custom.css'

export default class App extends Component {
    static displayName = App.name;
    static permisos = [];

    constructor(props) {
        super(props);
        this.state = { user: getUserLogged(), permisos: [] };
        //initializeIcons();
    };

    async componentDidMount() {
        if (this.state.user != null && 'token' in this.state.user) {
            let permisos1 = await apiClient.getProfessionalPermissions({ token: this.state.user.token });
            this.setState({ permisos: permisos1 });
        }
    }

    render() {
        const { user } = this.state;

        return (
            <div>
                <Router forceRefresh={true}>
                    <Protected user={user}>
                        <Layout>
                            <Route exact path="/" component={Home} />
                            <Switch>
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/reporthours").length > 0 && <Route exact path="/timesheettasking/reporthours" component={ReportHours} />}
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/validatehours").length > 0 && <Route exact path="/timesheettasking/validatehours" component={ValidateHours} />}
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/mockup").length > 0 && <Route exact path="/timesheettasking/mockup" component={Mockup} />}
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/reports").length > 0 && <Route exact path="/timesheettasking/reports" component={Reports} />}
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/overtimeEmployee").length > 0 && <Route exact path="/timesheettasking/overtimeEmployee" component={ReportOvertimeEmployee} />}
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/reportUtilisation").length > 0 && <Route exact path="/timesheettasking/reportUtilisation" component={ReportUtilisation} />}
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/externalEmployeeImputation").length > 0 && <Route exact path="/timesheettasking/externalEmployeeImputation" component={ExternalEmployeeImputation} />}
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/reportQHSE").length > 0 && <Route exact path="/timesheettasking/reportQHSE" component={ReportQHSE} />}
                                {this.state.permisos?.filter(p => p.accion == "/timesheettasking/adminPeriodos").length > 0 && <Route exact path="/timesheettasking/adminPeriodos" component={AdminPeriodos} />}

                                <Route path="/logout" component={Logout} />
                            </Switch>
                        </Layout>
                    </Protected>
                </Router>
            </div>
        );
    }
}